import useClaimEntity, { ClaimEntityProps } from 'hooks/useClaimEntity';
import Button, { ButtonProps } from './Button';

export default function ClaimEntityButton({ entityType, entityId, ...props }: ClaimEntityProps & ButtonProps) {
  const [{ message }, { handleClick }] = useClaimEntity({ entityType, entityId });

  return (
    <Button {...props} onClick={handleClick}>
      {message}
    </Button>
  );
}
